module.exports = __webpack_public_path__ + "static/media/Løk.6aeb7c1c.PNG";